document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".eventSwiper", {
    speed: 800,
    grabCursor: true,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 30,
    direction: "horizontal",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".custom-next",
      prevEl: ".custom-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      280: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      520: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 18,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });
  // Função para recalcular o layout quando o tamanho da janela muda
  window.addEventListener("resize", function () {
    swiper.update();
  });
});

// Toggle mobile menu
document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuButton = document.getElementById("mobile-menu-button");
  const mobileMenu = document.getElementById("mobile-menu");
  mobileMenuButton.addEventListener("click", () => {
    mobileMenu.classList.toggle("hidden");
  });

  // Toggle event schedule sidebar
  const eventScheduleButton = document.getElementById("event-schedule-button");
  const mobileEventScheduleButton = document.getElementById(
    "mobile-event-schedule-button"
  );
  const eventScheduleSidebar = document.getElementById(
    "event-schedule-sidebar"
  );

  function toggleEventSchedule() {
    eventScheduleSidebar.classList.toggle("-translate-x-full");
  }
  eventScheduleButton.addEventListener("click", toggleEventSchedule);
  mobileEventScheduleButton.addEventListener("click", toggleEventSchedule);

  // Close sidebar when clicking outside
  document.addEventListener("click", (event) => {
    if (
      !eventScheduleSidebar.contains(event.target) &&
      event.target !== eventScheduleButton &&
      event.target !== mobileEventScheduleButton
    ) {
      eventScheduleSidebar.classList.add("-translate-x-full");
    }
  });
});